import { render, staticRenderFns } from "./ZonasModalEdicion.vue?vue&type=template&id=2f353fce&scoped=true&"
import script from "./ZonasModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ZonasModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ZonasModalEdicion.vue?vue&type=style&index=0&id=2f353fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f353fce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f353fce', component.options)
    } else {
      api.reload('2f353fce', component.options)
    }
    module.hot.accept("./ZonasModalEdicion.vue?vue&type=template&id=2f353fce&scoped=true&", function () {
      api.rerender('2f353fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/ZonasModalEdicion.vue"
export default component.exports